// Limpieza del HTML de Mailchimp sin eliminar los dividers
document.addEventListener('DOMContentLoaded', function () {
  var root =
    document.querySelector('.article-template__content-rte') ||
    document.querySelector('.article-template__content .rte') ||
    document.querySelector('.article-template .rte');

  if (!root) return;

  var isInsideDivider = function (el) {
    return el.closest('.mcnDividerBlock') !== null;
  };

  // 1) Quitar bordes inline que generan “marcos”, excepto en los Divider
  root.querySelectorAll('[style*="border"]').forEach(function (el) {
    if (isInsideDivider(el)) return;
    el.style.border = '0';
    el.style.borderTop = '0';
    el.style.borderRight = '0';
    el.style.borderBottom = '0';
    el.style.borderLeft = '0';
  });

  // 2) Tablas maestras 600px -> 100%
  root.querySelectorAll('table[width="600"], table[style*="width:600px"]').forEach(function (tb) {
    tb.removeAttribute('width');
    tb.style.width = '100%';
    tb.style.maxWidth = '860px';
    tb.style.marginLeft = 'auto';
    tb.style.marginRight = 'auto';
    tb.style.border = '0';
  });

  // 3) Imágenes fluidas
  root.querySelectorAll('img').forEach(function (img) {
    img.style.maxWidth = '100%';
    img.style.height = 'auto';
    img.style.display = 'block';
    img.style.border = '0';
    img.style.outline = '0';
  });

  // 4) Quitar <p> vacíos (&nbsp; o <br> único)
  root.querySelectorAll('p').forEach(function (p) {
    var text = (p.textContent || '').replace(/\u00a0/g, '').trim();
    var onlyBr = p.children.length === 1 && p.children[0].tagName === 'BR';
    if (!text && (p.innerHTML.trim() === '' || onlyBr)) {
      p.remove();
    }
  });
});
